import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import WhyChooseSection from './components/WhyChooseSection';
import ServicesSection from './components/ServicesSection';
import ManufacturersSection from './components/ManufacturersSection';
import AdvantagesSection from './components/AdvantagesSection';
import AboutSection from './components/AboutSection';
import ContactPage from './components/ContactPage';
import Footer from './components/Footer';
import CustomCursor from './components/CustomCursor';
import AviationIntro from './components/AviationIntro';
import EnhancedAnimations from './components/EnhancedAnimations';
import AviationEffects from './components/AviationEffects';
import './App.css';

// Home Page Component
const HomePage = () => {
  return (
    <>
      <HeroSection />
      <WhyChooseSection />
      <ServicesSection />
      <ManufacturersSection />
      <AdvantagesSection />
      <AboutSection />
    </>
  );
};

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  const [showIntro, setShowIntro] = useState(true);
  const [introComplete, setIntroComplete] = useState(false);

  useEffect(() => {
    // Check if user has seen intro in this session
    const hasSeenIntro = sessionStorage.getItem('aviationIntroSeen');
    if (hasSeenIntro) {
      setShowIntro(false);
      setIntroComplete(true);
    }
  }, []);

  const handleIntroComplete = () => {
    sessionStorage.setItem('aviationIntroSeen', 'true');
    setShowIntro(false);
    setTimeout(() => {
      setIntroComplete(true);
    }, 100);
  };

  return (
    <BrowserRouter>
      <div className="App" style={{ cursor: 'none' }}>
        <CustomCursor />
        {showIntro && <AviationIntro onComplete={handleIntroComplete} />}
        
        <div className={`main-content ${introComplete ? 'intro-complete' : 'hidden'}`}>
          
          <EnhancedAnimations />
          <AviationEffects />
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
          <Footer />
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
